import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import styles from "./phoneTriggerShared.module.scss";

// The CRM-triggered call queue as both the survey's phone panel and Settings → Integrations →
// CRM connection show it, in Pivony's colours.
export const TRIGGER_KEY = "surveyManagement.distribute.phone.trigger";

const STATUS_TONES = {
  waiting: "purple",
  calling: "purple",
  answered: "purpleSolid",
  unreached: "pink",
  skipped: "neutral",
  cancelled: "neutral",
  dry_run: "neutral",
};

export const BrandTag = ({ tone = "neutral", children }) => (
  <span className={`${styles.tag} ${styles[tone] || styles.neutral}`}>{children}</span>
);

export const statusTag = (t, status) => (
  <BrandTag tone={STATUS_TONES[status]}>{t(`${TRIGGER_KEY}.status_${status}`, { defaultValue: status })}</BrandTag>
);

export const QueueStatus = ({ t, row }) => (
  <>
    {statusTag(t, row.status)}
    {row.test ? <BrandTag>{t(`${TRIGGER_KEY}.test_tag`)}</BrandTag> : null}
  </>
);

export const resultText = (t, row) =>
  row.result ? t(`${TRIGGER_KEY}.result_${row.result}`, { defaultValue: row.result }) : "";

/** An information box in the brand purple (pink for errors), instead of antd's coloured alerts. */
export const Notice = ({ error = false, title, children, className = "" }) => (
  <div className={`${styles.notice} ${error ? styles.noticeError : ""} ${className}`}>
    <InfoCircleOutlined />
    <div className={styles.noticeBody}>
      {title ? <div className={styles.noticeTitle}>{title}</div> : null}
      {children}
    </div>
  </div>
);

const SAMPLE_EVENT = {
  event_id: "rezervasyon-123456",
  phone: "+905321234567",
  name: "Ayşe Yılmaz",
  occurred_at: "2026-10-27T11:00:00+03:00",
  variables: { otel: "Voyage Torba" },
};

export const crmSampleRequest = (url, surveyId) =>
  [
    `curl -X POST ${url} \\`,
    `  -H "Content-Type: application/json" \\`,
    `  -H "X-Pivony-Token: <API_ANAHTARI>" \\`,
    `  -d '${JSON.stringify({ survey_id: surveyId, events: [SAMPLE_EVENT] }, null, 2)}'`,
  ].join("\n");
